
import { chunk } from 'lodash'
import { rules } from '~/mixin/common/product/productRules'
// import CommonImage from '~/components/common/CommonImage.vue'
import DaisoImage from '~/components/common/DaisoImage.vue'

export default {
  name: 'ProductListSwipe',
  components: {
    // CommonImage,
    DaisoImage
  },
  mixins: [rules],
  props: {
    details: {
      type: Object,
      default: () => {
        return {}
      }
    },
    productList: {
      type: Array,
      default: () => []
    },
    listType: {
      type: String,
      default: 'card1'
    },
    chunkCount: {
      type: Number,
      default: 5
    },
    useBundleSwipe: {
      type: Boolean,
      default: false
    },
    useLoop: {
      type: Boolean,
      default: false
    },
    useSwipePagination: {
      type: Boolean,
      default: true
    },
    // 중첩 swiper(부모 swiper 안에 있는) 케이스에서 true로 주면,
    // 자식 중간 스와이프는 자식만 처리하고 자식 양 끝에서만 부모로 터치 이벤트가 전파됨.
    nested: {
      type: Boolean,
      default: false
    },
    showController: {
      type: Boolean,
      default: false
    },
    isRankingProd: {
      type: Boolean,
      default: false
    },
    tabIndicator: {
      type: Array,
      default: null
    },
    keepCurrentTab: {
      type: String,
      default: '',
    },
    isProdGift: { // 상품권 여부
      type: Boolean,
      default: false
    },
    customFlags: {
      type: Array,
      default: () => {
        return []
      }
    },
    showMoreBtn: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      fbYn: false,
      swiperOpt: { // swiper options
        slidesPerView: (this.tabIndicator !== null && this.tabIndicator?.length > 0) || this.useBundleSwipe ? 1 : this.chunkCount,
        slidesPerGroup: (this.tabIndicator !== null && this.tabIndicator?.length > 0) || this.useBundleSwipe ? 1 : this.chunkCount,
        loop: this.useLoop,
        lazy: true,
        observer: true,
        observeParents: true,
        nested: this.nested,
        autoplay: false,
        navigation: {
          nextEl: `.swiper-button-next-${this._uid}`,
          prevEl: `.swiper-button-prev-${this._uid}`
        },
        pagination: false,
        threshold: 30,
        watchOverflow: true, // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
        slidesPerColumn: 1,
      },
      baseDetails: {
        rankingArea: false, // 랭킹 표기
        cancleStatus: false, // 취소완료
        price: true, // 가격
        boxFlag: true, // 박스 플래그
        emblem: true, // 엠블럼 전체 영역
        name: true, // 상품명
        purchaseStatus: false, // 구매 정보 표기 (주문&추천)
        option: false, // 상품 옵션
        code: false, // 상품 코드
        attribute: false, // 상품 속성
        thumbFlag: false,
        likeButton: true,
        flag: true, // 플래그
        rating: true, // 별점
        recommendLabel: false, // 추천 문구
        stock: false, // 재고
        date: false, // 날짜 표기 (재입고알림)
        alternativeButton: false,
        cancelRequestButton: false, // 신청 취소 버튼
        alarmButton: false, // 알림 신청 버튼
        shoppingbagButton: true,
        reviewButton: false, // 리뷰 작성 버튼
        deleteButton: false, // 삭제 버튼
      }
    }
  },
  computed: {
    chunkList () {
      return chunk(this.productList, this.chunkCount)
    },
    mergedDetails () {
      const merged = { ...this.baseDetails }
      Object.keys(this.details).forEach((key) => {
        merged[key] = this.details[key]
      })
      return merged
    },
    useIndicator () {
      return this.tabIndicator !== null && this.tabIndicator?.length > 0
    },
  },
  watch: {
    productList () {
      // 슬라이드 리스트 변화시 첫 슬라이드로 이동
      this.$nextTick(() => {
        if (this.$refs.productSwipe?.swiper) {
          this.$refs.productSwipe.swiper.slideTo(0)
        }
      })
    },
    keepCurrentTab () {
      this.updateSwiperPagination()
    }
  },
  created () {
    this.swiperOpt.pagination = this.getPaginationOption()
  },
  mounted () {
    const dynamicId = { ...this.$store.getters['ds/getDynamicId'] }
    this.fbYn = dynamicId?.fdrmOrPsblYn === 'Y' // 정기배송 여부
    const swiperInstance = this.$refs.productSwipe.swiper
    // if (this.keepCurrentTab && this.tabIndicator.includes(this.keepCurrentTab)) {
    //   this.activeTabIndicator = this.keepCurrentTab
    // } else if (this.tabIndicator?.length > 0) {
    //   // 기본값 설정
    //   this.activeTabIndicator = this.tabIndicator[1]
    // }
    // slideChange 이벤트 등록
    swiperInstance.on('slideChange', () => {
      this.activeTabIndicator = swiperInstance.realIndex
      this.$emit('activeTab', this.activeTabIndicator)
    })
  },
  updated () {
    this.updateSwiperPagination()
  },
  unmounted () {
  },
  methods: {
    updateSwiperPagination () {
      const swiper = this.$refs.productSwipe.swiper
      if (swiper.params.loop) {
        swiper.slideToLoop(0, 0)
      } else {
        swiper.slideTo(0, 0)
      }
    },
    getSwiper () {
      return this.$refs.productSwipe?.swiper
    },
    getPaginationOption () {
      const tabInd = this.tabIndicator

      if (this.useIndicator) {
        return {
          el: `.swiper-pagination-${this._uid}`,
          clickable: true,
          type: 'bullets',
          renderBullet (index, className) {
            return `<button type="button" aria-label="${index + 1}번 슬라이드로 이동하기" class="${className}"><span>${tabInd[index]}</span></button>`
          }
        }
      }

      if (this.showController) {
        return {
          el: `.swiper-pagination-${this._uid}`,
          type: 'fraction',
          renderFraction (currentClass, totalClass) {
            return `<span class="${currentClass}"></span><span class="divide">/</span><span class="${totalClass}"></span>`
          }
        }
      }

      return false
    },
    handleClickLink (item) {
      console.log(item)
      this.$emit('clickLink', item)
    },
    handleClickCart (item) {
      this.$emit('clickCart', item)
    },
    handleClickLike (item) {
      this.$emit('clickLike', item)
    },
    handleClickMore (evt) {
      this.$emit('clickMore', evt)
    },
    handleClickAlarm ({ evt, item }) {
      this.$emit('clickAlarm', { evt, item })
    },
    handleClickBanner (evt, item) {
      evt.preventDefault()
      this.$emit('clickBanner', item)
    },
    setEmblemImg (item) {
      if (item?.pcImgAtchFileUrl) {
        return item?.pcImgAtchFileUrl
      } else if (item?.emblmPcImgAtchFileUrl) {
        return item?.emblmPcImgAtchFileUrl?.replace('\n', '')
      } else if (item?.emblm_pc_img_atch_file_url) {
        return item?.emblm_pc_img_atch_file_url?.replace('\n', '')
      } else {
        return null
      }
    },
    setEmblemAlt (item) {
      if (item?.emblmNm) {
        return item?.emblmNm
      } else if (item?.emblm_nm) {
        return item?.emblm_nm
      }
      return '프로모션'
    },
    filterEmblemList (item) {
      const emblemList = Array.isArray(item.emblem)
        ? item.emblem
        : Array.isArray(item.emblm)
          ? item.emblm
          : []
      if (this.isBoxGoods(item)) {
        return emblemList.slice(0, 1)
      } else {
        return emblemList.slice(0, 2)
      }
    },
  }
}
